/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IExclusiveShell {
        cfncUrl: string;
        javaUrl: string;
        transitionsUrl: string;
    }

    class ExclusiveShell implements IExclusiveShell {
        static controllerId: string = "exclusiveShell"
        static $inject: Array<string> = ["$rootScope", "common", "config"]
        cfncUrl: string;
        javaUrl: string;
        transitionsUrl: string;

        constructor(private $rootScope: ng.IRootScopeService, private common: ICommonFactory, private config: IConfig) {
            this.activate();
        }

        activate(): void {
            this.common.activateController([], ExclusiveShell.controllerId);
            this.cfncUrl = this.config.cfncUrl;
            this.javaUrl = this.config.javaUrl;
            this.transitionsUrl = this.config.transitionsUrl;
        }
    }

    angular.module("app").controller(ExclusiveShell.controllerId, ExclusiveShell);
}